import React, { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import Header from "./Header";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import GetStorage from "../services/Storage";
import http from "../services/http";
import { showToast } from "./ShowToast";
import OTPInput, { ResendOTP } from "otp-input-react";
import { SpinnerCircular } from "spinners-react";
import HeaderLeft from "./HeaderLeft";
import DropdownRight from "./DropdownRight";

export default function OtpLogs(props) {
  const navigate = useNavigate();
  // const craditional = useSelector((state) => state.login.craditional);
  const [OTP, setOTP] = useState("");
  const [uploadSpin, setUploadSpin] = useState(false);
  const [error, setError] = useState("");

  const params = useParams();
  const { id, type } = params;

  const token = GetStorage.get("xAuthToken");

  // const ResendCode = () => {
  //   http
  //     .post(`public/parent/password/reset-request`, craditional)
  //     .then((res) => {
  //       console.log("response==>", res.data);
  //       showToast("success", "code has been sent");
  //     });
  // };

  const handleSubmit = async () => {
    setUploadSpin(true);
    http
      .post(`api/common/video_token`, {
        code: OTP,
        token: token,
      })
      .then((res) => {
        // setUploadSpin(false);
        GetVideo(res.data.video_token);
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              showToast("error", error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            showToast("error", error.response.data.message);
          }
        }
      });
  };

  const GetVideo = async (video_token) => {
    http
      .post(`api/common/get_video?token=${token}`, {
        video_token: video_token,
        type: type,
        id: id,
      })
      .then((res) => {
        setUploadSpin(false);

        console.log("video url ------->>>>", res.data);
        localStorage.setItem("url", JSON.stringify(res.data));
        navigate("/logsVideo");
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <body>
        <section className="otp_verification custom_hight">
          <div className="login_inner  pt-0">
            <h1 className="mb_30 main_title ">OTP Verification </h1>
            <p className="mb_40 them_para text-center mx-auto">
              We have sent a 6 digit OTP to your email.
              <br />
              Please enter the OTP to continue
            </p>

            <div className="otp_wraper">
              <OTPInput
                value={OTP}
                onChange={setOTP}
                autoFocus
                OTPLength={6}
                otpType="number"
                inputStyles={{ width: 60, height: 60 }}
                inputClassName="otp_input"
              />
            </div>
            <div className="btn_wraper">
              <button
                type="submit"
                className="them_btn mt_40 mb_30"
                onClick={handleSubmit}
              >
                {uploadSpin ? (
                  <SpinnerCircular className="button-spin" />
                ) : (
                  "Continue"
                )}
              </button>
            </div>
            {/*  <div style={{ flexDirection: "row" }}>
              <p className="them_para mx-auto  mt_20">
                Didn't Receive Code?
                <p
                  className="btn-link  "
                  onClick={ResendCode}
                  style={{
                    position: "absolute",
                    marginTop: -36,
                    marginRight: 50,
                    paddingLeft: 380,
                    cursor: "pointer",
                  }}
                >
                  {" "}
                  Resend Code
                </p>
              </p>
            </div> */}
          </div>
        </section>
        <ToastContainer />
      </body>
    </>
  );
}
